import React, { useEffect, useState } from "react";
import Doctor from "../Assets/doctor-picture.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleUp } from "@fortawesome/free-solid-svg-icons"; //faCalendarCheck
import "../Styles/Hero.css";
import { faHandshake } from "@fortawesome/free-solid-svg-icons";

function Hero() {
  const [goUp, setGoUp] = useState(false);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    const onPageScroll = () => {
      if (window.scrollY > 600) {
        setGoUp(true);
      } else {
        setGoUp(false);
      }
    };
    window.addEventListener("scroll", onPageScroll);

    return () => {
      window.removeEventListener("scroll", onPageScroll);
    };
  }, []);

  return (
    <div className="section-container">
      <div className="hero-section">
        <div className="text-section">
          {/* <p className="text-headline">💼 Where Excellence Meets Expectations</p> */}
          <h2 className="text-title">
            Hire the Right Talent Faster with Expert Support
          </h2>
          <p className="text-descritpion">
            Workforce Nexus helps organizations secure the right talent through focused recruitment support, industry-aware sourcing, and a highly professional approach to hiring coordination. Clear value propositions, dependable partnerships, and trust-led communication are essential to delivering effective workforce solutions.
          </p>
          <button
            className="text-appointment-btn"
            type="button"
            onClick={() => document.getElementById("contact").scrollIntoView()}
          >
            <FontAwesomeIcon icon={faHandshake} /> Connect With Hiring Support
          </button>
        </div>

        <div className="hero-image-section">
          <img className="hero-image1" src={Doctor} alt="Doctor" />
        </div>
      </div>

      <div
        onClick={scrollToTop}
        className={`scroll-up ${goUp ? "show-scroll" : ""}`}
      >
        <FontAwesomeIcon icon={faAngleUp} />
      </div>
    </div>
  );
}

export default Hero;
